import { UserRegulators } from '../regulation/user-regulators';
import { RegulatorMaster } from '../regulation/regulator-master';

export class UserRegulatorDto {
  userId: number;
  regulators: Array<RegulatorMaster>;
  userRegulators: Array<UserRegulators>;

  constructor() {
    this.userId = 0;
    this.regulators = [];
    this.userRegulators = [];
  }
}
